import { Button, Skeleton, Typography } from 'antd';
import clsx from 'clsx';
import { formatCurrency, getBalanceColor } from '../../utils';

const StatItem = ({ label, value, valueClass = '', loading = false }) => (
    <div className="stat-item">
        <span className="label">{label}</span>
        {loading ? (
            <Skeleton.Input active size="small" style={{ width: 72, minWidth: 72 }} />
        ) : (
            <span className={clsx('value', { [valueClass]: valueClass })}>{formatCurrency(value || 0)}</span>
        )}
    </div>
);

const CustomerBalanceWidget = ({ balance, isFullWidth = false, loading = false, error = false, onRetry }) => {
    const overdueColor = (balance?.overDueBalance ?? 0) > 0 ? 'red' : '';

    return (
        <div className={clsx('customer-balance-widget', { 'w-full': isFullWidth })}>
            {error ? (
                <div className="stat-item">
                    <Typography.Text type="danger">Balance could not be loaded</Typography.Text>
                    {onRetry && (
                        <Button type="link" size="small" onClick={onRetry}>
                            Retry
                        </Button>
                    )}
                </div>
            ) : (
                <>
                    <StatItem label="Credit Limit" value={balance?.creditLimit} loading={loading} />
                    <div className="divider" />
                    <StatItem
                        label="Balance"
                        value={balance?.balance}
                        valueClass={getBalanceColor(balance)}
                        loading={loading}
                    />
                    <div className="divider" />
                    <StatItem label="Overdue" value={balance?.overDueBalance} valueClass={overdueColor} loading={loading} />
                </>
            )}
        </div>
    );
};

export default CustomerBalanceWidget;
